import { formatMoney } from 'accounting'

import { faCog, faDownload, faPencil } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Checkbox, IconWithMenu, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import useInvoice, { generateUrls } from '@hooks/useInvoice'
import useAccountingIntegration from '@hooks/useAccountingIntegration'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import type { InvoiceModel } from '@models/types'

import { invoicePaymentStatus } from '@functions/invoice'

import InvoiceActionButton from '../../InvoiceActionButton'

interface InvoiceListItemProps {
  accountingIntegrationPayload: ReturnType<typeof useAccountingIntegration>,
  invoice: InvoiceModel,
}

const InvoiceListItem = (props: InvoiceListItemProps) => {
  const { accountingIntegrationPayload, invoice: initInvoice } = props

  const invoicePayload = useInvoice(initInvoice)

  const { campaign, downloadUrl, invoice } = invoicePayload

  const {
    amount_paid,
    approved,
    dates: {
      created,
    },
    debtor_name,
    id,
    paid,
    purchase_order,
    reference,
    total,
    void: isVoid,
  } = invoice

  const isEditable = !approved

  // @ts-expect-error TS2339
  const { editInvoiceUrl } = generateUrls(invoice, { prefixRoute: `agency/campaigns/${campaign.id}/edit/accounting` })

  return (
    <Box
      marginBottom="large"
      variant="white"
      flexDirection="column"
    >
      {/*
       // @ts-expect-error TS2339 */}
      <ListItem.WithCheckbox
        boxProps={{
          paddingX: 'large',
          paddingY: 'medium',
        }}
        checkbox={(
          <Checkbox
            checked={approved}
            fontSize="small"
            style={{ cursor: 'auto' }}
          />
          )}
        disableHover
      >
        <Box flexDirection="column" marginRight="auto" width={['150px', 'auto']}>
          <Text fontSize="small" variant="ellipsis">
            {/*
             // @ts-expect-error TS2339 */}
            {campaign.address || reference}
          </Text>

          <Text
            color={isVoid ? 'faintGrey' : 'bodyFontLightColor'}
            fontSize="xsmall"
            marginTop="small"
            variant="ellipsis"
          >
            {reference}
          </Text>
        </Box>

        <Box justifyContent="flex-end" width="fit-content">
          <InvoiceActionButton
            accountingPayload={accountingIntegrationPayload}
            invoice={invoice}
          />
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </ListItem.WithCheckbox>

      <Box justifyContent="space-between" padding="large">
        <Box flexDirection="column" fontSize="xsmall" justifyContent="center" maxWidth="50%">
          <Text color="faintGrey" variant="ellipsis">
            {/*
             // @ts-expect-error TS2339 */}
            {`Invoice #${id} - ${created.date}`} {isVoid ? '(Void)' : ''}
          </Text>

          <Text color="bodyFontLightColor" marginTop="small" variant="ellipsis">
            {debtor_name}
          </Text>

          {purchase_order && (
            <Text color="bodyFontLightColor" marginTop="small">
              {purchase_order}
            </Text>
          )}
        </Box>

        <Box flexDirection="column" marginRight="large" textAlign="right" justifyContent="center">
          <Text fontSize="medium">
            {formatMoney(total)}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" justifyContent="center">
            {/*
             // @ts-expect-error TS2322 */}
            {invoicePaymentStatus({ total, paid, amount_paid })}
          </Text>
        </Box>

        <IconWithMenu
          boxProps={{ alignItems: 'center', position: 'relative' }}
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faCog} />
            </Link>
          )}
          shouldUsePortal
        >
          {/*
           // @ts-expect-error TS2741 */}
          <IconWithMenu.Menu closeOnClick>
            {isEditable && (
              <Link href={editInvoiceUrl} key="edit">
                <FontAwesomeIcon icon={faPencil} />Manage Invoice
              </Link>
            )}

            <AuthenticatedDownload key="download-pdf">
              <Link href={downloadUrl} key="download" target="blank">
                <FontAwesomeIcon icon={faDownload} /> Download
              </Link>
            </AuthenticatedDownload>
          </IconWithMenu.Menu>
        </IconWithMenu>
      </Box>
    </Box>
  )
}

export default InvoiceListItem
